/**
 * FormGroup — DS Molecule
 * Label + slot input (children) + message erreur/aide
 */

import styles from './FormGroup.module.css';

interface FormGroupProps {
  label: string;
  htmlFor?: string;
  error?: string;
  hint?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

export function FormGroup({ label, htmlFor, error, hint, required = false, children, className = '' }: FormGroupProps) {
  return (
    <div className={`${styles.group} ${className}`}>
      <label className={styles.label} htmlFor={htmlFor}>
        {label}
        {required && <span className={styles.required}>*</span>}
      </label>
      {children}
      {error && <span className={styles.error}><i className="bi bi-exclamation-circle me-1" />{error}</span>}
      {hint && !error && <span className={styles.hint}>{hint}</span>}
    </div>
  );
}
